import { render } from "./TheLoginForm.vue?vue&type=template&id=4de5b531&scoped=true&ts=true"
import script from "./TheLoginForm.vue?vue&type=script&lang=ts"
export * from "./TheLoginForm.vue?vue&type=script&lang=ts"

import "./TheLoginForm.vue?vue&type=style&index=0&id=4de5b531&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de5b531"]])

export default __exports__